import { FuelButton } from '@frete.com/fuel-react';
import { openSearchStatesLabels } from 'hooks/openSearchTrucker/types';
import { useEmptySearch } from 'hooks/openSearchTrucker/useEmptySearch';
import InviteDriverBenefits from 'open-search/components/InviteDriverBenefits';
import React, { FC } from 'react';
import GenericState from '../GenericState';

const Empty: FC = () => {
  const {
    propsEmptySearch: { whatsAppButtonProps, benefitsButtonProps, benefitsModalProps },
  } = useEmptySearch();

  return (
    <>
      <GenericState
        icon="search"
        iconSize="medium"
        iconColor="default"
        title={openSearchStatesLabels.emptyState.title}
        message={openSearchStatesLabels.emptyState.message}
        testId="mobile-empty-state"
      >
        <FuelButton variant="secondary" size="medium" onClick={benefitsButtonProps.events.onClick} fullWidth>
          {benefitsButtonProps.states.textContentMobile}
        </FuelButton>
        <FuelButton variant="whatsapp" onClick={whatsAppButtonProps.events.onClick} fullWidth>
          {whatsAppButtonProps.states.textContent}
        </FuelButton>
      </GenericState>

      <InviteDriverBenefits {...benefitsModalProps} />
    </>
  );
};

export default Empty;
